export default "__VITE_ASSET__a_IfFN_z__"